<div
  class="fixed-top text-right"
  style="top: 90px; right: 20px; left: 20px"
>
  <i
    class="ri-close-circle-fill cursor-pointer"
    (click)="this.closeEditor()"
    [ngStyle]="{ color: layoutService.activeColor.backgroundColor }"
  ></i>
</div>

@if (!isVimeoVideo) {
<video
  controls
  controlsList="nodownload"
  disablePictureInPicture
  [src]="'/api/document/get/' + videoId | secure | async"
  i18n="@@videoTagNotSupported"
>
  Your browser does not support the video tag.
</video>
}
@if (isVimeoVideo) {
<iframe
  i18n-title="@@videoProviderVimeoTitle"
  title="Vimeo"
  alt="Vimeo"
  [src]="vimeoUrl"
  width="100%"
  height="99%"
  frameborder="0"
  allow="autoplay; fullscreen; picture-in-picture"
  allowfullscreen
></iframe>
}